import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  page_background: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100vh - 152px)'
  },
  btn_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  btn_home: {
    // width: '100%'
    backgroundColor: theme?.palette?.primary?.lighter
  }
}));
